export const QUALITY = { 1: 'Clunky', 2: 'Rough', 3: 'Smooth', 4: 'Snappy' };
export const EASE = { 1: 'Mechanical', 2: 'Cautious', 3: 'Natural', 4: 'Relaxed' };
export const DENSITY = { 1: 'Chill', 2: 'Steady', 3: 'Heavy', 4: 'Intense' };
export const PREPARATION_ANSWER = { 1: 'Ready', 2: 'Tired' };
